<template>
  <div class="single">
    <div class="row">
      <label class="col-sm-3 control-label pt-10"> Pickup Date* </label>
      <div class="col-sm-8">
        <date-picker
          v-model="data.pickupDate"
          required
          :disabled-date="disabledDate"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  data: {
    type: Object,
    required: true,
  },

  disabledDate: {
    type: Function,
    default: () => null,
  },
});

</script>
